// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"2b639cb4","458":"504d2c50","674":"7ddc3a85","769":"37686d72","924":"42fe51e2"}[chunkId] + ".chunk.js";
};